import React from 'react';
import { connect } from 'react-redux';

const LoadingBar = ({ loading }) =>
    loading ? (
        <span className="loading-bar" data-debug-id="Portal_Loader">
            <span className="subline inc" />
            <span className="subline dec" />
        </span>
    ) : null;

const mapStateToProps = state => ({
    loading:
        state.header.loading ||
        state.sslApplicationsManagement.loading ||
        state.sslCertificatesManagement.loading ||
        state.reports.loading ||
        state.usersManagement.loading ||
        state.policyDistributions.loading ||
        state.policyTemplates.loading ||
        state.serviceOverview.loading ||
        state.serviceOverviewToolbar.loading ||
        state.securityEvents.loading ||
        state.applicationInsights.loading ||
        state.botAnalytics.loading ||
        state.ipAnalytics.loading ||
        state.serviceProviders.loading ||
        state.activityLog.pageLoading ||
        state.accounts.loading,
});

export default connect(mapStateToProps)(LoadingBar);
